import { AuthContext } from 'common/providers/AuthContextProvider/AuthContextProvider';
import { Role, useCurrentUserQuery } from 'generated/graphql';
import { useContext } from 'react';
import { Datagrid, DateField, DeleteButton, EditButton, TextField } from 'react-admin';

export const FinancialReserveDatagrid: React.FC = () => {
  const { isAuthenticated } = useContext(AuthContext);
  const { data } = useCurrentUserQuery({ skip: !isAuthenticated });

  const hasAnyRole = (allowedRoles: Role[]) =>
    isAuthenticated && data?.user?.roles?.some((role: Role) => allowedRoles.includes(role));

  const showEditButton = hasAnyRole([Role.RoleFinancialAdvisor, Role.RoleAdmin]);
  const showDeleteButton = hasAnyRole([Role.RoleFinancialAdvisor, Role.RoleAdmin]);

  return (
    <Datagrid bulkActionButtons={false} rowClick="show">
      <TextField label="ID" source="id" />
      <DateField label="Dátum vytvorenia" locales="sk" source="creationTimestamp" />
      <DateField label="Dátum zmeny" locales="sk" source="updateTimestamp" />
      <TextField label="Forma finančnej rezervy" source="text" />
      <TextField label="Suma" source="amount.amount" />
      {showEditButton && <EditButton />}
      {showDeleteButton && <DeleteButton mutationMode="pessimistic" redirect="" />}
    </Datagrid>
  );
};
